import { Fragment, useState } from 'react';
import { t } from '@lingui/core/macro';
import { Trans } from '@lingui/react/macro';
import { Button } from '@pocketlaw/tetris';
import { ActivityEntry, ActivityEntryText } from 'app/domains/common-ui/ActivityLog';
import { RequirementCheckedDialog } from './RequirementCheckedDialog';
import { getIcon } from './utils';
export function ApprovalRequestRequirementChecked(props) {
    const { user, timestamp, documentChatId } = props;
    const [renderDialog, setRenderDialog] = useState(false);
    const fallbackName = t({
        message: 'Unknown',
        comment: 'Fallback name when user does not exist',
    });
    const userName = (user === null || user === void 0 ? void 0 : user.name) || fallbackName;
    const openDialog = () => setRenderDialog(true);
    const closeDialog = () => setRenderDialog(false);
    return (<Fragment>
      {renderDialog && (<RequirementCheckedDialog userName={userName} timestamp={timestamp} documentChatId={documentChatId} onClose={closeDialog}/>)}
      <ActivityEntry appearance="info" icon={getIcon('warning')} timestamp={timestamp} text={<ActivityEntryText>
            <Trans comment="Approval activity - User ran an approval requirement check">
              <b>{userName}</b> ran an approval requirement check
            </Trans>
          </ActivityEntryText>}>
        <Button size="xs" appearance="secondary" onClick={openDialog}>
          <Trans comment="Approval activity - View details button label">View details</Trans>
        </Button>
      </ActivityEntry>
    </Fragment>);
}
